import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import {
  Error,
  NotAuthorized,
  NotFound,
} from '@iarc-programing/emanufac-components/src/components/Error';
import { MainFooter } from '@iarc-programing/emanufac-components/src/components/Footers';
import { Loading } from '@iarc-programing/emanufac-components/src/components/Loading';
import { HomeNavbar } from '@iarc-programing/emanufac-components/src/components/Navbars';
import { MainSidebar } from '@iarc-programing/emanufac-components/src/components/Sidebar';

import * as actions from '../redux/actions';
import accessRight from '../utils/functions/accessRight';
import { DashboardMenu } from '../views/Dashboard';

export function Dashboard() {
  const module = 'DASHBOARD';
  const prefix = '/dashboard';
  const name = 'แดชบอร์ด';

  const dispatch = useDispatch();
  const me = useSelector((state) => state.me);
  const availableModule = useSelector((state) => state.availableModule);
  const information = useSelector((state) => state.information);
  const { pathname } = useLocation();

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    console.log('Layout: Profile');
    dispatch(actions.meGet());
    dispatch(actions.informationAll());
    dispatch(actions.availableModuleAll());
    return () => {};
  }, []);

  if (!me?.userData || me?.isLoading) {
    return <Loading />;
  }

  if (!me.isLoading && !me.isCompleted) {
    return <Error message="ไม่สามารถโหลดข้อมูลได้" />;
  }

  if (accessRight(me, module, 0, availableModule)) {
    return (
      <div className="min-h-screen">
        <Helmet>
          <meta charSet="utf-8" />
          <title>แดชบอร์ด - {information?.name || 'E-Manufac'}</title>
        </Helmet>
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <div className="lg:ml-64  min-h-screen  pt-16 px-8 ">
          <div className="py-4">
            <Switch>
              <Redirect exact from={`${prefix}`} to={`${prefix}/main`} />
              <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />

              <Route exact path={`${prefix}/main`}>
                <DashboardMenu title="แดชบอร์ด" subtitle={name} />
              </Route>

              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="min-h-screen">
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <NotAuthorized />
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
